import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { ChatInput } from './ChatInput';
import { ChatMessage } from './ChatMessage';
import { mockData } from '../utils/mockData';
import type { Message } from '../App';
interface ChatViewProps {
  messages: Message[];
  isLoading: boolean;
  onSendMessage: (message: string) => void;
}
export const ChatView = ({
  messages,
  isLoading,
  onSendMessage
}: ChatViewProps) => {
  const {
    id
  } = useParams();
  const messagesEndRef = useRef<HTMLDivElement>(null);
  // Get the correct conversation based on the chat ID
  const conversationMessages = id ? mockData.conversations[id as keyof typeof mockData.conversations] || messages : messages;
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    scrollToBottom();
  }, [conversationMessages]);
  return <div className="flex flex-col h-full w-full" data-id="element-86">
      <div className="flex-grow overflow-y-auto p-6 md:p-8 w-full" style={{
      backgroundImage: 'radial-gradient(circle at center, #2d4c6b 0%, #1f1f1f 100%)'
    }} data-id="element-87">
        <div className="max-w-[800px] mx-auto w-full" data-id="element-88">
          {conversationMessages.map(message => <ChatMessage key={message.id} message={message} data-id="element-89" />)}
          {isLoading && <div className="flex items-center gap-2 p-4 ml-16" data-id="element-90">
              <div className="flex space-x-2" data-id="element-91">
                {[0, 200, 400].map(delay => <div key={delay} className="w-2.5 h-2.5 bg-[#4a90e2] rounded-full animate-bounce" style={{
              animationDelay: `${delay}ms`,
              animationDuration: '600ms'
            }} data-id="element-92" />)}
              </div>
            </div>}
          <div ref={messagesEndRef} data-id="element-93" />
        </div>
      </div>
      <div className="p-4 md:p-6 bg-[#1f1f1f] border-t border-[#444444] w-full" data-id="element-94">
        <ChatInput onSendMessage={onSendMessage} data-id="element-95" />
      </div>
    </div>;
};